import { Navigate, useLocation } from "react-router-dom";
import { checkIfAuthenticated } from "../utils/utils";
import { useEffect, useState } from "react";

const RequireAuth = ({ children }) => {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(
    checkIfAuthenticated()
  );

  useEffect(() => {
    const validateAuth = () => {
      setIsAuthenticated(checkIfAuthenticated());
    };

    validateAuth();

    const interval = setInterval(() => {
      validateAuth();
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  if (!isAuthenticated) {
    // Guarda a rota requisitada para o LoginPage devolver o usuário a ela
    // depois de autenticar.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireAuth;
